import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { PURPOSE, SIZE } from '@snack-uikit/typography';
export var getTitleTypographyProps = function getTitleTypographyProps(_ref) {
  var layoutType = _ref.layoutType;
  switch (layoutType) {
    case LAYOUT_TYPE.Mobile:
    case LAYOUT_TYPE.Tablet:
      return {
        purpose: PURPOSE.Title,
        size: SIZE.L
      };
    case LAYOUT_TYPE.Desktop:
    case LAYOUT_TYPE.DesktopSmall:
    default:
      return {
        purpose: PURPOSE.Headline,
        size: SIZE.S
      };
  }
};
export var getTitleTruncateMaxLines = function getTitleTruncateMaxLines(_ref2) {
  var layoutType = _ref2.layoutType;
  switch (layoutType) {
    case LAYOUT_TYPE.Mobile:
      return 5;
    case LAYOUT_TYPE.Tablet:
      return 3;
    case LAYOUT_TYPE.Desktop:
    case LAYOUT_TYPE.DesktopSmall:
    default:
      return 2;
  }
};